/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const personBodySchema = z.object({
  name: z.string().min(1),
  slug: z.string().min(1).optional(),
  sortName: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  birthday: z.string().nullable().optional(),
  deathday: z.string().nullable().optional(),
  birthplace: z.string().nullable().optional(),
  gender: z.string().nullable().optional(),
  knownForDepartment: z.string().nullable().optional(),
  tmdbId: z.number().nullable().optional(),
  imdbId: z.string().nullable().optional(),
  sortOrder: z.number().optional(),
});

export type IPersonBody = z.infer<typeof personBodySchema>;
